const RAC_LINK = 'https://docs.netmaker.io/pro/rac.html';
const WIREGUARD_LINK = 'https://docs.netmaker.io/integrating-non-native-devices.html';
const PRO_UPGRADE_DOCS_LINK = 'https://docs.netmaker.io/pro/pro-setup.html';
const RAC_DOWNLOAD_DOCS_LINK = 'https://docs.netmaker.io/pro/rac.html#download-installation';

const EGRESS_IMG = '/egress.webp';
const RAG_IMG = '/rag.webp';
const NET_IMG = '/network.webp';

export const ExternalLinks = {
  RAC_LINK,
  WIREGUARD_LINK,
  PRO_UPGRADE_DOCS_LINK,
  RAC_DOWNLOAD_DOCS_LINK,
};

export const AppImages = {
  EGRESS_IMG,
  RAG_IMG,
  NET_IMG,
};
